import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc, collection, query, where, getDocs, setDoc, updateDoc, orderBy, addDoc } from "firebase/firestore";
import { db } from "./firebase";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";
import "./studentpanel.css";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { motion } from "framer-motion";
import { storage } from "./firebase"; 







const StudentDashboard = () => {
  const [selectedOption, setSelectedOption] = useState("home"); // Default to "home"
  const [studentEmail, setStudentEmail] = useState("");
  const [profileData, setProfileData] = useState(null); // To store user data
  const [messageType, setMessageType] = useState("inquiry");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [notices, setNotices] = useState([]); // State to hold fetched notices
  const [assignmentDeadlines, setAssignmentDeadlines] = useState([]); // State to hold assignment deadlines
 

  //google classroom links
const [googleclassroomLink, setGoogleClassroomLink] = useState("")


  // Download course materials
  const [materials, setMaterials] = useState([]);


    // Dropdown button for assignments
  const [isLearningDropdownOpen, setLearningDropdownOpen] = useState(false);
  const toggleLearningDropdown = () => {
    setLearningDropdownOpen(!isLearningDropdownOpen);
  };

  


  // Dropdown button for assignments
  const [isAssignmentDropdownOpen, setAssignmentDropdownOpen] = useState(false);
  const toggleAssignmentDropdown = () => {
    setAssignmentDropdownOpen(!isAssignmentDropdownOpen);
  };


//result dropdown
  const [isResultsDropdownOpen, setResultsDropdownOpen] = useState(false);
  const toggleResultsDropdown = () => {
    setResultsDropdownOpen(!isResultsDropdownOpen);
  };


  // Assignment state
  const [assignments, setAssignments] = useState([]); // Assignments to display

  // Course modules
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // User Registration ID is fetched properly from profileData
  const userRegistrationId = profileData?.registrationNumber;
  const userBatch = profileData?.batch;  // User's batch

  const auth = getAuth();
  const navigate = useNavigate();

  // Student result
  const [results, setResults] = useState([]);

//assignment upload only three times
const [uploadProgress, setUploadProgress] = useState(0);
const [isUploading, setIsUploading] = useState(false);
const [uploadAttempts, setUploadAttempts] = useState({}); // Track upload attempts per module

  // Student payment
  const [payments, setPayments] = useState([]);
  const [courseFee, setCourseFee] = useState(0);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);

//fetch quiz link
const [quizLinks, setQuizLinks] = useState([]);
const [userRegistrationNumber, setUserRegistrationNumber] = useState("");


//fetch lecture recording links
const [lectureRecordingLink, setLectureRecordingLink] = useState([])




// Google classroom links and study materials link  
const [googleClassroomLinks, setGoogleClassroomLinks] = useState([]);
const [studyMaterialFiles, setStudyMaterialFiles] = useState([]);




  // Logout function
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };






 // Snowflake generator
//  useEffect(() => {
//   const createSnowflake = () => {
//     const snowflake = document.createElement("div");
//     snowflake.className = "snowflake";
//     snowflake.style.left = Math.random() * 100 + "vw";
//     snowflake.style.animationDuration = Math.random() * 3 + 2 + "s"; // Varying speed
//     snowflake.style.opacity = Math.random(); // Varying opacity
//     document.body.appendChild(snowflake);

//     setTimeout(() => {
//       snowflake.remove();
//     }, 5000); // Remove snowflake after animation
//   };

//   const interval = setInterval(createSnowflake, 100); // Create a snowflake every 100ms
//   return () => clearInterval(interval); // Cleanup interval on unmount
// }, []);










    // Fetch assignments based on batch and registrationNumber
    // const fetchAssignments = async (userBatch, userRegistrationNumber) => {
    //   const assignmentsRef = collection(db, 'assignments'); // Use db to reference Firestore
  
    //   // Extract the course prefix (CO or DO) from the registration number
    //   const coursePrefix = userRegistrationNumber.split('-')[0];
      
    //   try {
    //     console.log("Fetching assignments for batch:", userBatch, "and course prefix:", coursePrefix);  // Debugging info
        
    //     const snapshot = await query(
    //       assignmentsRef,
    //       where('batch', '==', userBatch),
    //       where('id', '==', coursePrefix) // Match the prefix of registration number
    //     );
  
    //     const querySnapshot = await getDocs(snapshot);
      
    //     if (querySnapshot.empty) {
    //       console.log("No assignments found for batch:", userBatch, "and course:", coursePrefix);
    //       return [];
    //     }
      
    //     // Log the fetched documents for debugging
    //     console.log("Assignments fetched:", querySnapshot.docs.map(doc => doc.data()));
      
    //     // Map the snapshot to an array of assignments
    //     const assignments = querySnapshot.docs.map(doc => doc.data());
    //     return assignments;
        
    //   } catch (error) {
    //     console.error("Error fetching assignments:", error.message);
    //     throw new Error(`Error fetching assignments: ${error.message}`);
    //   }
    // };




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


const fetchAssignments = async (userBatch, userRegistrationNumber) => {
  const assignmentsRef = collection(db, 'assignments');
  const coursePrefix = userRegistrationNumber.split('-')[0];

  try {
    console.log("Fetching assignments for batch:", userBatch, "and course prefix:", coursePrefix);

    const q = query(
      assignmentsRef,
      where('batch', '==', userBatch),
      where('id', '==', coursePrefix) // make sure this field exists in Firestore
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log("No assignments found for batch:", userBatch, "and course:", coursePrefix);
      return [];
    }

    const assignments = querySnapshot.docs.map(doc => doc.data());
    console.log("Assignments fetched:", assignments);
    console.log("Querying with batch:", userBatch, "and id:", coursePrefix);

    return assignments;

  } catch (error) {
    console.error("Error fetching assignments:", error.message);
    throw new Error(`Error fetching assignments: ${error.message}`);
  }
};





useEffect(() => {
  if (userBatch && userRegistrationNumber) {
    const getAssignments = async () => {
      try {
        const fetchedAssignments = await fetchAssignments(userBatch, userRegistrationNumber);
        setAssignments(fetchedAssignments);
      } catch (error) {
        console.error("Error fetching assignments:", error);
      }
    };
    getAssignments();
  }
}, [userBatch, userRegistrationNumber]);








  // Fetch assignment deadlines based on batch and moduleCode
  // const fetchAssignmentDeadlines = async (userBatch, userRegistrationId) => {
  //   const assignmentDetailsRef = collection(db, "assignmentSubmissionDetails");
  
  //   const coursePrefix = userRegistrationId.split("-")[0];
  
  //   try {
  //     setLoading(true);
  //     console.log("Fetching assignment deadlines for batch:", userBatch, "and course prefix:", coursePrefix);
  
  //     const snapshot = await getDocs(
  //       query(
  //         assignmentDetailsRef,
  //         where("batch", "==", userBatch),
  //         where("id", "==", coursePrefix)
  //       )
  //     );
  
  //     if (snapshot.empty) {
  //       console.log("No assignment deadlines found for this batch and course.");
  //       setAssignmentDeadlines([]);
  //       return;
  //     }
  
  //     const deadlines = snapshot.docs.map((doc) => {
  //       const data = doc.data();
  //       const deadlineDate = data.submissionDeadline.toDate();
  
  //       // Format: DD Month YYYY
  //       const formattedDeadline = deadlineDate.toLocaleDateString('en-GB', {
  //         day: '2-digit',
  //         month: 'long',
  //         year: 'numeric',
  //       });
  
  //       return {
  //         moduleCode: data.moduleCode,
  //         moduleName: data.moduleName,
  //         submissionDeadline: formattedDeadline,
  //         uploadLink: data.uploadLink,
  //       };
  //     });
  
  //     setAssignmentDeadlines(deadlines);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching assignment deadlines:", error);
  //     setLoading(false);
  //   }
  // };
  
  // // Fetch data on initial render
  // useEffect(() => {
  //   if (profileData) {
  //     fetchAssignmentDeadlines(userBatch, userRegistrationId);
  //   }
  // }, [profileData]);





////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  
// Fetch assignment deadlines based on batch and moduleCode
const fetchAssignmentDeadlines = async (userBatch, userRegistrationId) => {
  const assignmentDetailsRef = collection(db, "assignmentSubmissionDetails");
  const coursePrefix = userRegistrationId.split("-")[0];

  try {
    setLoading(true);
    console.log("Fetching assignment deadlines for batch:", userBatch, "and course prefix:", coursePrefix);

    // First query: Get all assignments for the batch and course prefix
    const baseQuery = query(
      assignmentDetailsRef,
      where("batch", "==", userBatch),
      where("id", "==", coursePrefix)
    );

    const snapshot = await getDocs(baseQuery);

    if (snapshot.empty) {
      console.log("No assignment deadlines found for this batch and course.");
      setAssignmentDeadlines([]);
      return;
    }

    // Filter documents based on registrationNumber if it exists
    const filteredDocs = snapshot.docs.filter(doc => {
      const data = doc.data();
      // If registrationNumber field exists, check if it matches current user
      if (data.registrationNumber) {
        return data.registrationNumber === userRegistrationId;
      }
      // If no registrationNumber field, include the document
      return true;
    });

    if (filteredDocs.length === 0) {
      console.log("No assignment deadlines match the current user's registration number.");
      setAssignmentDeadlines([]);
      return;
    }

    const deadlines = filteredDocs.map((doc) => {
      const data = doc.data();
      const deadlineDate = data.submissionDeadline.toDate();

      // Format: DD Month YYYY
      const formattedDeadline = deadlineDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });

      return {
        moduleCode: data.moduleCode,
        moduleName: data.moduleName,
        submissionDeadline: formattedDeadline,
        uploadLink: data.uploadLink,
      };
    });

    setAssignmentDeadlines(deadlines);
    setLoading(false);
  } catch (error) {
    console.error("Error fetching assignment deadlines:", error);
    setLoading(false);
  }
};

// Fetch data on initial render
useEffect(() => {
  if (profileData) {
    fetchAssignmentDeadlines(userBatch, userRegistrationId);
  }
}, [profileData]);
  
  




////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



  // upload assignment with progress bar working perfectly


  // const handleFileUpload = async (e, moduleCode) => {
  //   e.preventDefault();
  
  //   // Check if the user has exceeded 3 upload attempts for this module
  //   if (uploadAttempts[moduleCode] >= 3) {
  //     alert("You have reached the maximum upload attempts for this assignment.");
  //     return;
  //   }
  
  //   const file = e.target.elements.file.files[0];
  //   if (!file) {
  //     alert("Please select a file to upload.");
  //     return;
  //   }
  
  //   try {
  //     setIsUploading(true); // Start uploading
  //     const storage = getStorage();
  //     const storageRef = ref(storage, `assignments/${moduleCode}/${file.name}`);
  //     const uploadTask = uploadBytesResumable(storageRef, file);
  
  //     uploadTask.on(
  //       "state_changed",
  //       (snapshot) => {
  //         const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
  //         setUploadProgress(progress); // Update progress state
  //         console.log(`Upload is ${progress}% done`);
  //       },
  //       (error) => {
  //         console.error("Error during upload:", error);
  //         alert("Failed to upload file.");
  //         setIsUploading(false); // Stop uploading on error
  //       },
  //       async () => {
  //         const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
  //         console.log("File available at:", downloadURL);
  //         alert("File uploaded successfully!");
  
  //         // Increment the upload attempt for this module
  //         setUploadAttempts((prevAttempts) => ({
  //           ...prevAttempts,
  //           [moduleCode]: (prevAttempts[moduleCode] || 0) + 1,
  //         }));
  
  //         setIsUploading(false); // Stop uploading on success
  //         setUploadProgress(0); // Reset progress
  //       }
  //     );
  //   } catch (error) {
  //     console.error("Error uploading file:", error);
  //     alert("An error occurred during file upload. Please try again.");
  //     setIsUploading(false); // Stop uploading on error
  //   }
  // };

 const handleFileUpload = async (e, moduleCode) => {
  e.preventDefault();
  const file = e.target.elements.file.files[0];
  
  if (!file) {
    alert('Please select a file first');
    return;
  }

  // Validate file type
  const validTypes = ['application/pdf', 'application/msword', 
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  if (!validTypes.includes(file.type)) {
    alert('Please upload only PDF or Word documents');
    return;
  }

  setIsUploading(true);
  setUploadProgress(0);

  try {
    // Verify user is authenticated
    if (!auth.currentUser) {
      throw new Error('User not authenticated');
    }

    // Find the module details from assignmentDeadlines
    const moduleDetails = assignmentDeadlines.find(a => a.moduleCode === moduleCode);

    // Get current user details
    const userDetails = {
      registrationNumber: userRegistrationId,
      batch: userBatch,
      course: profileData?.course || '',
      name: profileData?.name || '',
      moduleCode,
      moduleName: moduleDetails?.moduleName || '', // Get moduleName from assignmentDeadlines
      userId: auth.currentUser.uid, // Critical for security
      email: auth.currentUser.email || '',
      submissionTime: new Date().toISOString()
    };

    // Create filename with proper formatting
    const sanitizedName = userDetails.name.replace(/\s+/g, '_');
    const fileExtension = file.name.split('.').pop();
    const fileName = `${userDetails.batch}_${moduleCode}_${sanitizedName}_${userDetails.registrationNumber}.${fileExtension}`;

    // Upload file to storage
    const storageRef = ref(storage, `assignments/${fileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on('state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
      },
      (error) => {
        console.error("Upload failed:", error);
        setIsUploading(false);
        alert(`Upload failed: ${error.message}`);
      },
      async () => {
        try {
          // Get download URL
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          
          // Prepare submission data
          const submissionData = {
            ...userDetails,
            fileName,
            downloadURL,
            status: "submitted",
            originalFileName: file.name,
            fileSize: file.size,
            submissionDeadline: moduleDetails?.submissionDeadline,
            timestamp: new Date().toISOString()
          };

          // Save to Firestore
          await addDoc(collection(db, "assignmentStudentDetails"), submissionData);

          setIsUploading(false);
          alert("Assignment submitted successfully!");
        } catch (dbError) {
          console.error("Database error:", dbError);
          setIsUploading(false);
          alert(`Failed to save submission: ${dbError.message}`);
        }
      }
    );
  } catch (error) {
    console.error("Error:", error);
    setIsUploading(false);
    alert(`An error occurred: ${error.message}`);
  }
};


  // Fetch the logged-in user's email
  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      setStudentEmail(user.email);
    }
  }, [auth.currentUser]);



  

  // Handle Send Message with EmailJS
  const handleSend = (e) => {
    e.preventDefault();

    const templateParams = {
      student_email: studentEmail, // Sender's email
      message_type: messageType, // Selected message type
      subject, // Subject of the message
      message, // Message body
    };

    emailjs
      .send(
        "service_dydfq54", // Replace with your EmailJS service ID
        "template_4cpxr7d", // Replace with your EmailJS template ID
        templateParams,
        "VwLqHWZ1TXYthG21f" // Replace with your EmailJS user ID
      )
      .then(
        (response) => {
          alert("Message sent successfully!");
          handleClear(); // Clear the form after sending
        },
        (error) => {
          console.error("Failed to send message:", error);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  // Handle Clear Form
  const handleClear = () => {
    setMessageType("inquiry");
    setSubject("");
    setMessage("");
  };














////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




  // Fetch the currently logged-in user's email and profile data from Firestore
  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;

      if (user) {
        setStudentEmail(user.email);

        // Fetch user details from Firestore
        const docRef = doc(db, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setProfileData(docSnap.data());
        } else {
          console.error("No user data found!");
        }
      }
    };

    fetchUserData();
  }, [auth.currentUser]);















////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


const [selectedImage, setSelectedImage] = useState(null);

  // // Fetch notices from Firestore when the component loads or selectedOption changes
  // useEffect(() => {
  //   const fetchNotices = async () => {
  //     if (selectedOption === "notice") {
  //       try {
  //         const querySnapshot = await getDocs(collection(db, "notices"));
  //         const noticesData = querySnapshot.docs.map((doc) => ({
  //           id: doc.id,
  //           ...doc.data(),
  //         }));
  //         setNotices(noticesData);
  //       } catch (error) {
  //         console.error("Error fetching notices: ", error);
  //       }
  //     }
  //   };
  //   fetchNotices();
  // }, [selectedOption]);

useEffect(() => {
  const fetchNotices = async () => {
    if (selectedOption === "notice") {
      try {
        const querySnapshot = await getDocs(collection(db, "notices"));
        const noticesData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        
        // Sort notices by date (newest first)
        noticesData.sort((a, b) => {
          const dateA = a.addedDate?.seconds || 0;
          const dateB = b.addedDate?.seconds || 0;
          return dateB - dateA; // For descending order
        });
        
        setNotices(noticesData);
      } catch (error) {
        console.error("Error fetching notices: ", error);
      }
    }
  };
  fetchNotices();
}, [selectedOption]);













////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // // Fetch course module
  // useEffect(() => {
  //   if (!userRegistrationId) return; // Avoid fetch if userRegistrationId is not available

  //   const fetchModules = async () => {
  //     setLoading(true);
  //     setError("");

  //     try {
  //       // Extract prefix (e.g., "CO") from the user's registration ID
  //       const userProgramPrefix = userRegistrationId.split("-")[0];

  //       // Firestore query to fetch modules matching the user's program
  //       const modulesRef = collection(db, "cmodule");
  //       const q = query(modulesRef, where("id", "==", userProgramPrefix));
  //       const querySnapshot = await getDocs(q);

  //       const modulesData = querySnapshot.docs.map((doc) => doc.data());
  //       setModules(modulesData);
  //     } catch (err) {
  //       console.error("Error fetching modules:", err);
  //       setError("Failed to fetch course modules. Please try again later.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchModules();
  // }, [userRegistrationId]); // This will re-fetch modules when userRegistrationId changes




// Fetch course module
useEffect(() => {
  if (!userRegistrationId) return; // Avoid fetch if userRegistrationId is not available

  const fetchModules = async () => {
    setLoading(true);
    setError("");

    try {
      // Extract prefix (e.g., "CO") from the user's registration ID
      const userProgramPrefix = userRegistrationId.split("-")[0];

      // Firestore query to fetch modules matching the user's program
      const modulesRef = collection(db, "cmodule");
      const q = query(modulesRef, where("id", "==", userProgramPrefix));
      const querySnapshot = await getDocs(q);

      let modulesData = querySnapshot.docs.map((doc) => doc.data());

      // ✅ Semester order map
      const semesterOrder = {
        "Y1 S1": 1,
        "Y1 S2": 2,
        "Y2 S3": 3,
        "Y2 S4": 4,
        "Y3 S5": 5,
      };

      // ✅ Apply custom sorting
      modulesData.sort((a, b) => {
        const getNum = (code) => {
          if (!code || code === "-") return null; // special case for "-"
          const match = code.match(/\d+/);
          return match ? parseInt(match[0], 10) : null;
        };

        const numA = getNum(a.moduleCode);
        const numB = getNum(b.moduleCode);

        if (numA !== null && numB !== null) {
          // both have module codes → sort numerically
          if (numA !== numB) {
            return numA - numB;
          }
        } else if (numA !== null && numB === null) {
          // A has code, B is "-"
          return -1; // A comes first
        } else if (numA === null && numB !== null) {
          // B has code, A is "-"
          return 1; // B comes first
        }

        // If both are "-" OR same moduleCode → sort by semester order
        const orderA = semesterOrder[a.semester] ?? 9999;
        const orderB = semesterOrder[b.semester] ?? 9999;
        return orderA - orderB;
      });

      setModules(modulesData);

    } catch (err) {
      console.error("Error fetching modules:", err);
      setError("Failed to fetch course modules. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  fetchModules();
}, [userRegistrationId]);


  







////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Fetch student results based on registrationNumber and batch
  useEffect(() => {
    if (!profileData) return; // Ensure profile data is loaded

    const fetchResults = async () => {
      setLoading(true);
      setError("");

      try {
        const resultsRef = collection(db, "results");

        // Firestore query to fetch results based on registrationNumber and batch
        const q = query(
          resultsRef,
          where("registrationNumber", "==", profileData.registrationNumber),
          where("batch", "==", profileData.batch)
        );
        const querySnapshot = await getDocs(q);

        const resultsData = querySnapshot.docs.map((doc) => doc.data());
        console.log(resultsData); // Log the fetched results for debugging

        // Set the fetched results in the state
        setResults(resultsData);
      } catch (err) {
        console.error("Error fetching results:", err);
        setError("Failed to fetch results. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [profileData]); // This will run when profileData is loaded




////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



 // Fetch course fee from the users collection ////////////////////////////////////////////////////////////////////////////////////////////////////////
 const fetchCourseFee = useCallback(async () => {
  try {
    const userId = auth.currentUser?.uid;

    if (!userId) {
      console.error("User is not authenticated.");
      return;
    }

    console.log("Fetching course fee for User ID:", userId);

    const userDocRef = doc(db, "users", userId);
    const userDoc = await getDoc(userDocRef);

    if (!userDoc.exists()) {
      console.error("User document not found.");
      return;
    }

    const userData = userDoc.data();
    console.log("User data retrieved:", userData);

    setCourseFee(userData.courseFee || 0); // Set courseFee
  } catch (error) {
    console.error("Error fetching course fee:", error.code, error.message);
  }
}, []);






// Fetch payments  ////////////////////////////////////////////////////////////////////////////////////////////////////////
const fetchStudentPayments = useCallback(async () => {
  try {
    if (!userRegistrationId) {
      console.log("No registration number found.");
      return;
    }

    // Query the payments collection based on the student's registration number
    const q = query(
      collection(db, "payments"),
      where("registrationNumber", "==", userRegistrationId)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log("No payments found for this registration number.");
      setPayments([]); // Set empty array if no payments
      setTotalAmountPaid(0); // Reset total amount paid
      return;
    }

    const paymentsList = [];
    let totalPaid = 0;

    querySnapshot.forEach((doc) => {
      const payment = doc.data();
      paymentsList.push({ id: doc.id, ...payment });
      
      totalPaid += payment.amount; // Sum up payment amounts
    });









    // Sort payments by date (earliest first)
    paymentsList.sort((a, b) => new Date(a.date) - new Date(b.date)); // Adjust `date` field name if needed

    

    setPayments(paymentsList);
    setTotalAmountPaid(totalPaid); // Update total amount paid
  } catch (error) {
    console.error("Error fetching payments: ", error);
  }
}, [userRegistrationId]);

useEffect(() => {
  if (userRegistrationId) {
    fetchCourseFee();
    fetchStudentPayments();
  }
}, [userRegistrationId, fetchCourseFee, fetchStudentPayments]);

const outstandingAmount = courseFee - totalAmountPaid;











///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

 
const [searchTerm, setSearchTerm] = useState("");
const [moduleFilter, setModuleFilter] = useState("");
const [codeFilter, setCodeFilter] = useState("");


{/* Fetch lecture materials based on registrationNumber and batch */}
 useEffect(() => {
  if (!profileData) return; // Ensure profile data is loaded before fetching

  const fetchMaterials = async () => {
    setLoading(true);
    setError("");

    try {
      const materialsRef = collection(db, "materials");

      // Extract prefix (CO/DO) from the student's registrationNumber
      const programPrefix = profileData.registrationNumber.split("-")[0];

      // Firestore query to fetch materials based on id (CO/DO) and batch
      const q = query(
        materialsRef,
        where("id", "==", programPrefix), // Match program (CO/DO)
        where("batch", "==", profileData.batch) // Match batch
      );

      const querySnapshot = await getDocs(q);

      // Map fetched documents into an array of materials
      const materialsData = querySnapshot.docs.map((doc) => ({
        id: doc.data().id, // Program ID (CO/DO)
        documentId: doc.id, // Unique Firestore document ID
        moduleName: doc.data().moduleName,
        moduleCode: doc.data().moduleCode,
        fileUrl: doc.data().fileUrl, // Assuming fileUrl is stored in Firestore
      }));

      console.log(materialsData); // Log materials for debugging

      // Set the fetched materials in the state
      setMaterials(materialsData);
    } catch (err) {
      console.error("Error fetching materials:", err);
      setError("Failed to fetch materials. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  fetchMaterials();
}, [profileData]); // This will run whenever profileData is loaded







//fetch the assignment  ////////////////////////////////////////////////////////////////////////////////////////////////////////
useEffect(() => {
  const fetchAssignments = async () => {
    try {
      const user = auth.currentUser;
      if (user) {
        // Get the student's data
        const userRef = doc(db, 'users', user.uid); // Use doc() instead of collection()
        const userDoc = await getDoc(userRef); // Fetch the user's data
        
        if (!userDoc.exists()) {
          console.error("User data not found");
          return;
        }

        const userData = userDoc.data();
        console.log("User Data:", userData); // Log the entire user data

        // Log each individual field
        console.log("Batch:", userData.batch);
        console.log("Registration Number:", userData.registrationNumber);
        console.log("Program:", userData.program); // Make sure this exists

        // Check if necessary fields are available
        if (!userData.batch || !userData.registrationNumber || !userData.program) {
          console.error("Missing user data fields: batch, registrationNumber, or program");
          return;
        }

        // Prepare the query to fetch assignments
        const assignmentsRef = collection(db, 'assignments');
        const q = query(
          assignmentsRef,
          where('batch', '==', userData.batch)
        );
        
        const querySnapshot = await getDocs(q);
        const assignmentsList = querySnapshot.docs.map((doc) => doc.data());
        setAssignments(assignmentsList);
      }
    } catch (error) {
      console.error('Error fetching assignments:', error);
    } finally {
      setLoading(false);
    }
  };

  fetchAssignments();
}, [auth.currentUser]);





//fetch quiz links  ////////////////////////////////////////////////////////////////////////////////////////////////////////
// Fetch current user's registration number

useEffect(() => {
  const fetchUserData = async () => {
    try {
      const userDocRef = doc(db, "users", auth.currentUser.uid);
      const userDoc = await getDoc(userDocRef);
      if (userDoc.exists()) {
        const registrationNumber = userDoc.data().registrationNumber;
        setUserRegistrationNumber(registrationNumber);


    const courseType = 
    registrationNumber.startsWith("CO") ? "CO" :
    registrationNumber.startsWith("COO") ? "COO" :
    registrationNumber.startsWith("HDO") ? "HDO" :
    "DO"; // Default to "DO" if neither "CO" nor "HDO"


        // Fetch quiz links for the respective course type
        const q = query(
          collection(db, "quizMaster"),
          where("courseType", "==", courseType)
        );

        const querySnapshot = await getDocs(q);

        const links = [];
        querySnapshot.forEach((doc) => {
          links.push({ id: doc.id, ...doc.data() });
        });

        setQuizLinks(links);
      } else {
        console.log("No such user document!");
      }
    } catch (error) {
      console.error("Error fetching quiz links: ", error);
    }
  };

  fetchUserData();
}, []);



/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//fetch Lecture Recording links
// Fetch current user's registration number

// useEffect(() => {
//   const fetchUserData = async () => {
//     try {
//       const userDocRef = doc(db, "users", auth.currentUser.uid);
//       const userDoc = await getDoc(userDocRef);
//       if (userDoc.exists()) {
//         const registrationNumber = userDoc.data().registrationNumber;
//         setUserRegistrationNumber(registrationNumber);

//         // Determine the course type from registration number
//         const courseType = registrationNumber.startsWith("CO") ? "CO" : "DO";

//         // Fetch quiz links for the respective course type
//         const q = query(
//           collection(db, "lectureRecordings"),
//           where("courseType", "==", courseType)
//         );

//         const querySnapshot = await getDocs(q);

//         const links = [];
//         querySnapshot.forEach((doc) => {
//           links.push({ id: doc.id, ...doc.data() });
//         });

//         setLectureRecordingLink(links);
//       } else {
//         console.log("No such user document!");
//       }
//     } catch (error) {
//       console.error("Error fetching recording links: ", error);
//     }
//   };

//   fetchUserData();
// }, []);














//fetch google classroom links ////////////////////////////////////////////////////////////////////////////////////////////////////////
// Fetch current user's registration number


  useEffect(() => {
    const fetchStudyMaterials = async () => {
      try {
        const userDocRef = doc(db, "users", auth.currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (!userDoc.exists()) return;

        const registrationNumber = userDoc.data().registrationNumber;
        setUserRegistrationNumber(registrationNumber);

        const courseType =
          registrationNumber.startsWith("COO") ? "COO" :
          registrationNumber.startsWith("CO") ? "CO" :
          registrationNumber.startsWith("HDO") ? "HDO" :
          "DO";

        // Fetch all study materials for this courseType
        const q = query(
          collection(db, "googleclassroom"),
          where("courseType", "==", courseType.trim())
        );

        const querySnapshot = await getDocs(q);

        const links = [];
        const files = [];

        querySnapshot.forEach((doc) => {
          const data = doc.data();
          if (data.includeFile) {
            // Treat as file
            files.push({ id: doc.id, ...data });
          } else if (data.googleclassroomLink) {
            // Treat as link
            links.push({ id: doc.id, ...data });
          }
        });

        setGoogleClassroomLinks(links);
        setStudyMaterialFiles(files);
      } catch (error) {
        console.error("Error fetching study materials:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchStudyMaterials();
  }, []);
























// Fetch current user's registration number and lecture recordings  ////////////////////////////////////////////////////////////////////////////////////////////////////////

  // // Filtered recordings for search/module filter
  // const filteredRecordings = useMemo(() => {
  //   if (!Array.isArray(lectureRecordingLink)) return [];

  //   return lectureRecordingLink.filter((module) => {
  //     if (!module || !module.moduleName || !module.sessions) return false;

  //     const moduleMatches =
  //       !moduleFilter ||
  //       module.moduleName.toLowerCase().includes(moduleFilter.toLowerCase());

  //     const searchMatches =
  //       !searchTerm ||
  //       module.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //       module.sessions.some(
  //         (session) =>
  //           session &&
  //           session.session &&
  //           session.lectureRecordingLink &&
  //           (session.session.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //             session.lectureRecordingLink.toLowerCase().includes(searchTerm.toLowerCase()))
  //       );

  //     return moduleMatches && searchMatches;
  //   });
  // }, [lectureRecordingLink, searchTerm, moduleFilter]);

  // // Fetch current user's registration number, batch, and lecture recordings
  // useEffect(() => {
  //   const fetchUserData = async () => {
  //     try {
  //       const userDocRef = doc(db, "users", auth.currentUser.uid);
  //       const userDoc = await getDoc(userDocRef);

  //       if (userDoc.exists()) {
  //         const registrationNumber = userDoc.data().registrationNumber;
  //         const batch = userDoc.data().batch; // Make sure 'batch' exists in user document
  //         setUserRegistrationNumber(registrationNumber);

  //         const courseType =
  //           registrationNumber.startsWith("COO")
  //             ? "COO"
  //             : registrationNumber.startsWith("CO")
  //             ? "CO"
  //             : registrationNumber.startsWith("HDO")
  //             ? "HDO"
  //             : "DO";

  //         const q = query(
  //           collection(db, "lectureRecordings"),
  //           where("courseType", "==", courseType),
  //           where("batch", "==", batch)
  //         );

  //         const querySnapshot = await getDocs(q);

  //         // Group recordings by module and sort by session number
  //         const groupedRecordings = {};
  //         querySnapshot.forEach((doc) => {
  //           const data = doc.data();
  //           if (!groupedRecordings[data.moduleName]) {
  //             groupedRecordings[data.moduleName] = [];
  //           }
  //           groupedRecordings[data.moduleName].push({
  //             id: doc.id,
  //             ...data,
  //             sessionNumber: parseInt(data.session.replace("Session ", "")),
  //           });
  //         });

  //         // Sort sessions within each module
  //         for (const module in groupedRecordings) {
  //           groupedRecordings[module].sort(
  //             (a, b) => a.sessionNumber - b.sessionNumber
  //           );
  //         }

  //         // Convert to array format for easier rendering
  //         const sortedRecordings = Object.entries(groupedRecordings).map(
  //           ([moduleName, sessions]) => ({ moduleName, sessions })
  //         );

  //         // Sort modules alphabetically (optional)
  //         sortedRecordings.sort((a, b) => a.moduleName.localeCompare(b.moduleName));

  //         setLectureRecordingLink(sortedRecordings);
  //       } else {
  //         console.log("No such user document!");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching recording links: ", error);
  //     }
  //   };

  //   fetchUserData();
  // }, []);




  




  const [expandedSessions, setExpandedSessions] = useState({});

   // Expand / collapse handler
  const toggleSession = (moduleName, sessionName) => {
    const key = `${moduleName}-${sessionName}`;
    setExpandedSessions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // Fetch lecture recordings
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userDocRef = doc(db, "users", auth.currentUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (!userDoc.exists()) return;

        const registrationNumber = userDoc.data().registrationNumber;
        const batch = userDoc.data().batch;

        setUserRegistrationNumber(registrationNumber);

        const courseType =
          registrationNumber.startsWith("COO")
            ? "COO"
            : registrationNumber.startsWith("CO")
            ? "CO"
            : registrationNumber.startsWith("HDO")
            ? "HDO"
            : "DO";

        const q = query(
          collection(db, "lectureRecordings"),
          where("courseType", "==", courseType),
          where("batch", "==", batch)
        );

        const querySnapshot = await getDocs(q);

        // MODULE → SESSION → PART (or just SESSION)
        const grouped = {};

        querySnapshot.forEach((docSnap) => {
          const data = docSnap.data();
          if (!data.moduleName || !data.session) return;

          if (!grouped[data.moduleName]) grouped[data.moduleName] = {};
          if (!grouped[data.moduleName][data.session])
            grouped[data.moduleName][data.session] = [];

          // Normalize lectureRecordingLink to array
          const links = Array.isArray(data.lectureRecordingLink)
            ? data.lectureRecordingLink
            : data.lectureRecordingLink
            ? [data.lectureRecordingLink]
            : [];

          const partNumber = data.part
            ? Number(data.part.match(/\d+/)?.[0] || 0)
            : 0; // If no part, default to 0

          grouped[data.moduleName][data.session].push({
            id: docSnap.id,
            part: data.part || "Lecture", // Default label if no part
            lectureRecordingLink: links,
            partNumber,
          });
        });

        // Sort parts
        Object.keys(grouped).forEach((module) => {
          Object.keys(grouped[module]).forEach((session) => {
            grouped[module][session].sort((a, b) => a.partNumber - b.partNumber);
          });
        });

        // Convert for rendering
        const formatted = Object.entries(grouped).map(([moduleName, sessions]) => ({
          moduleName,
          sessions: Object.entries(sessions)
            .map(([sessionName, parts]) => ({
              sessionName,
              sessionNumber: Number(sessionName.match(/\d+/)?.[0] || 0),
              parts,
            }))
            .sort((a, b) => a.sessionNumber - b.sessionNumber),
        }));

        formatted.sort((a, b) => a.moduleName.localeCompare(b.moduleName));

        setLectureRecordingLink(formatted);
      } catch (error) {
        console.error("Error fetching lecture recordings:", error);
      }
    };

    fetchUserData();
  }, []);

  // Search & filter
  const filteredRecordings = useMemo(() => {
    if (!Array.isArray(lectureRecordingLink)) return [];

    return lectureRecordingLink.filter((module) => {
      if (!module?.sessions?.length) return false;

      const moduleMatch = !moduleFilter || module.moduleName === moduleFilter;
      if (!moduleMatch) return false;

      if (!searchTerm) return true;

      return (
        module.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        module.sessions.some((session) =>
          session.parts.some(
            (part) =>
              part.part?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              part.lectureRecordingLink.some((link) =>
                link.toLowerCase().includes(searchTerm.toLowerCase())
              )
          )
        )
      );
    });
  }, [lectureRecordingLink, searchTerm, moduleFilter]);









//fetch Placement assignment according to the current user  ////////////////////////////////////////////////////////////////////////////////////////////////////////
// At the top with other state declarations
const [placements, setPlacements] = useState([]);
const [userData, setUserData] = useState(null); // Add this line


// Fetch placements with noOfPlacement field
useEffect(() => {
  const fetchPlacements = async () => {
    try {
      setLoading(true);
      setError('');
      
      if (!auth.currentUser) {
        throw new Error('You must be logged in');
      }

      const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid));
      if (!userDoc.exists()) {
        throw new Error('User data not found');
      }

      const userData = userDoc.data();
      setUserData(userData);
      const studentBatch = userData.batch;
      const registrationNumber = userData.registrationNumber;

      if (!studentBatch || !registrationNumber) {
        throw new Error('Your profile is missing batch or registration number');
      }

      // Determine course from registration number
      let studentCourse;
      if (registrationNumber.startsWith('DO')) studentCourse = 'DO';
       else if (registrationNumber.startsWith('COO')) studentCourse = 'COO';
      else if (registrationNumber.startsWith('CO')) studentCourse = 'CO';
      else if (registrationNumber.startsWith('HDO')) studentCourse = 'HDO';
      else throw new Error('Invalid registration number format');

      const q = query(
        collection(db, 'placements'),
        where('batch', '==', studentBatch),
        where('course', '==', studentCourse),
        orderBy('createdAt', 'desc')
      );

      const querySnapshot = await getDocs(q);
      const placementsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
        noOfPlacement: doc.data().noofPlacement || 'N/A', // Handle case sensitivity
        createdAt: doc.data().createdAt?.toDate()
      }));

      setPlacements(placementsData);
      
    } catch (err) {
      console.error("Error fetching placements:", err);
      setError(err.message);
      setPlacements([]);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "assignmentPlacement") {
    fetchPlacements();
  }
}, [selectedOption, auth.currentUser]);







//results for continuous assessment  ////////////////////////////////////////////////////////////////////////////////////////////////////////
const [continuousAssessmentResults, setContinuousAssessmentResults] = useState([]);

useEffect(() => {
  const fetchContinuousAssessmentResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch as required by your rules
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Continuous Assessment'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push(doc.data());
      });
      
      setContinuousAssessmentResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "continuouslyAssessmentResults") {
    fetchContinuousAssessmentResults();
  }
}, [selectedOption]);







//results for paractical exam  ////////////////////////////////////////////////////////////////////////////////////////////////////////
const [practicalExamResults, setPracticalExamResults] = useState([]);



useEffect(() => {
  const fetchPracticalExamResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch as required by your rules
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Practical Exam'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push(doc.data());
      });
      
      setPracticalExamResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "practicalExamResults") {
    fetchPracticalExamResults();
  }
}, [selectedOption]);







//results for final Exam  ////////////////////////////////////////////////////////////////////////////////////////////////////////
const [finalExamResults, setFinalExamResults] = useState([]);



useEffect(() => {
  const fetchFinalExamResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Final Exam'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push(doc.data());
      });

      // Sort by moduleCode (ascending), then by attemptNo (ascending)
      results.sort((a, b) => {
        const moduleA = a.moduleCode?.toString().toLowerCase() || '';
        const moduleB = b.moduleCode?.toString().toLowerCase() || '';
        if (moduleA < moduleB) return -1;
        if (moduleA > moduleB) return 1;

        // if moduleCode is same, sort by attemptNo as number
        const attemptA = parseInt(a.attemptNo) || 0;
        const attemptB = parseInt(b.attemptNo) || 0;
        return attemptA - attemptB;
      });
      
      setFinalExamResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "finalExamResults") {
    fetchFinalExamResults();
  }
}, [selectedOption])





//results for assignment  ////////////////////////////////////////////////////////////////////////////////////////////////////////
const [assignmentResults, setAssignmentResults] = useState([]);



useEffect(() => {
  const fetchAssignmentResults = async () => {
    try {
      setLoading(true);
      setError('');
      
      const user = auth.currentUser;
      if (!user) {
        throw new Error('User not authenticated');
      }
      
      // First fetch the user document to get registrationNumber and batch
      const userDoc = await getDoc(doc(db, 'users', user.uid));
      if (!userDoc.exists()) {
        throw new Error('User document not found');
      }
      
      const userData = userDoc.data();
      const registrationNumber = userData.registrationNumber;
      const batch = userData.batch;
      
      if (!registrationNumber || !batch) {
        throw new Error('Missing required user data');
      }
      
      // Query with both registrationNumber AND batch as required by your rules
      const q = query(
        collection(db, 'results'),
        where('typeOfAssesment', '==', 'Assignment Result'),
        where('registrationNumber', '==', registrationNumber),
        where('batch', '==', batch)
      );
      
      const querySnapshot = await getDocs(q);
      const results = [];
      querySnapshot.forEach((doc) => {
        results.push(doc.data());
      });
      
      setAssignmentResults(results);
    } catch (err) {
      setError('Failed to fetch results: ' + err.message);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (selectedOption === "assignmentResults") {
    fetchAssignmentResults();
  }
}, [selectedOption]);












// //correct code for 
// const getResultForModule = (results, moduleCode) => {
//   const result = results.find(r => r.moduleCode === moduleCode);
//   return result ? result.grade : 'N/A';
// };

// // Helper function to determine if a grade is failing/NYC
// const isFailingGrade = (grade) => {
//   return ['F', 'AB', 'N/A'].includes(grade);
// };

// // Helper function to calculate status for a module
// const calculateStatus = (assignment, continuous, practical, final) => {
//   const grades = [assignment, continuous, practical, final];
  
//   // Check if any grade is failing (F, AB, N/A)
//   const hasAnyFailing = grades.some(grade => isFailingGrade(grade));
  
//   // Check if all grades are either passing (A+, A, B+, B, C) or '-'
//   const allPassingOrDash = grades.every(grade => 
//     ['A+', 'A', 'B+', 'B', 'C', '-'].includes(grade)
//   );
  
//   if (hasAnyFailing) {
//     // If any failing grade exists, status is NYC
//     return 'NYC';
//   } else if (allPassingOrDash) {
//     // All grades are passing or '-'
//     return 'COMPLETED';
//   } else {
//     // This case shouldn't happen with current grade options
//     return 'PENDING';
//   }
// };

// // Helper function to get combined results
// const getCombinedResults = () => {
//   const allResults = [
//     ...continuousAssessmentResults,
//     ...practicalExamResults,
//     ...finalExamResults,
//     ...assignmentResults
//   ];
  
//   // Get unique modules
//   const uniqueModules = {};
//   allResults.forEach(result => {
//     if (!uniqueModules[result.moduleCode]) {
//       uniqueModules[result.moduleCode] = {
//         moduleName: result.moduleName,
//         moduleCode: result.moduleCode
//       };
//     }
//   });
  
//   return Object.values(uniqueModules);
// };
// ✅ Get the latest (highest attempt) result for a given module
const getResultForModule = (results, moduleCode) => {
  // Filter all results for this specific module
  const moduleResults = results.filter(r => r.moduleCode === moduleCode);

  if (moduleResults.length === 0) return 'N/A';

  // Sort by attemptNo (descending) so the latest attempt comes first
  const sorted = moduleResults.sort((a, b) => {
    const attemptA = parseInt(a.attemptNo) || 0;
    const attemptB = parseInt(b.attemptNo) || 0;
    return attemptB - attemptA;  // latest attempt first
  });

  // Return the grade of the latest attempt
  return sorted[0].grade || 'N/A';
};

// ✅ Helper function to determine if a grade is failing/NYC
const isFailingGrade = (grade) => {
  return ['F', 'AB', 'N/A'].includes(grade);
};

// ✅ Helper function to calculate status for a module
const calculateStatus = (assignment, continuous, practical, final) => {
  const grades = [assignment, continuous, practical, final];

  const hasAnyFailing = grades.some(grade => isFailingGrade(grade));
  const allPassingOrDash = grades.every(grade =>
    ['A+', 'A', 'B+', 'B', 'C', '-'].includes(grade)
  );

  if (hasAnyFailing) {
    return 'NYC'; // Not Yet Completed
  } else if (allPassingOrDash) {
    return 'COMPLETED';
  } else {
    return 'PENDING';
  }
};

// ✅ Helper function to get combined results
const getCombinedResults = () => {
  const allResults = [
    ...continuousAssessmentResults,
    ...practicalExamResults,
    ...finalExamResults,
    ...assignmentResults
  ];

  const uniqueModules = {};
  allResults.forEach(result => {
    if (!uniqueModules[result.moduleCode]) {
      uniqueModules[result.moduleCode] = {
        moduleName: result.moduleName,
        moduleCode: result.moduleCode
      };
    }
  });

  return Object.values(uniqueModules);
};








//vIEW THEIR OWN Assignment SUBMISSION/////////////////////////////////////////////////////////////////////////////////////////////////////////

// State for student submissions
const [submittedAssignments, setSubmittedAssignments] = useState([]);

// Fetch student's submitted assignments
const fetchStudentSubmissions = async () => {
  setLoading(true);
  try {
    if (!auth.currentUser) return;
    
    // Query assignments for the current student
    const q = query(
      collection(db, "assignmentStudentDetails"),
      where("userId", "==", auth.currentUser.uid)
    );
    
    const querySnapshot = await getDocs(q);
    const submissions = [];
    
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      submissions.push({
        id: doc.id,
        ...data,
        // Format deadline if it's a Firestore timestamp
        submissionDeadline: data.submissionDeadline?.toDate 
          ? new Date(data.submissionDeadline.toDate()).toLocaleDateString()
          : data.submissionDeadline
      });
    });
    
    // Sort by submission time (newest first)
    submissions.sort((a, b) => 
      new Date(b.submissionTime) - new Date(a.submissionTime)
    );
    
    setSubmittedAssignments(submissions);
  } catch (error) {
    console.error("Error fetching submissions:", error);
    alert("Failed to load your submissions");
  } finally {
    setLoading(false);
  }
};

// Fetch data when component mounts or auth changes
useEffect(() => {
  if (selectedOption === "submittedAssignment") {
    fetchStudentSubmissions();
  }
}, [selectedOption, auth.currentUser]);








  return (
      // <div className="student-dashboard-container">

     <div className="student-dashboard-container">

         {/* <div id="snow-container" className="student-dashboard-container"> */}

      {/* <div className="santa-container">
        <img src="/santaimg.png" alt="Santa with Reindeer and Cart" className="santa" />
      </div> */}


<div className="sun-overlay">
            <div className="sun-container">
              <img src="/sun.png" alt="Sun with New Year" className="sun" />
            </div>
          </div>

          {/* <div className="sun-overlay">
            <div className="sun-container">
              <img src="/vesak.png" alt="Sun with New Year" className="sun" />
            </div>
          </div>*/}

          {/* <div className="sun-overlay">
            <div className="sun-container">
              <img src="/sri-lankan-flag-sri-lanka.webp" alt="Sri Lanka" className="sun" />
            </div>
          </div>  */}



       <div className="student-sidebar">
         <h2 className="student-sidebar-title">Student Panel</h2>
         <ul className="student-sidebar-list">
           <li onClick={() => setSelectedOption("home")}>Home</li>
           <li onClick={() => setSelectedOption("profile")}>Student Profile</li>
           <li onClick={() => setSelectedOption("payment")}>Student Payment</li>
           <li onClick={() => setSelectedOption("module")}>Course Module</li>
           <li onClick={() => setSelectedOption("materials")}>Lecture Materials</li>
      
           <li onClick={toggleLearningDropdown} style={{ cursor: "pointer" }}>
           Resources {isLearningDropdownOpen ? "▼" : "▶"}
            </li>
            {isLearningDropdownOpen && (
              <ul style={{ paddingLeft: "20px" }}>
                <li onClick={() => setSelectedOption("learningResources")}>
                Learning Resources
                </li>
                <li onClick={() => setSelectedOption("studyMaterials")}>
                Study Materials
                </li> 
                  </ul>
                )} 

           <li onClick={() => setSelectedOption("guidelines")}>Downloads</li>
           {/* <li onClick={() => setSelectedOption("assignmentBrief")}>Assignments Schedule</li> */}
            {/*<li onClick={() => setSelectedOption("assignmentSubmission")}>Assignment Submission</li> */}
               
             <li onClick={toggleAssignmentDropdown} style={{ cursor: "pointer" }}>
              Assignments {isAssignmentDropdownOpen ? "▼" : "▶"}
            </li>
            {isAssignmentDropdownOpen && (
              <ul style={{ paddingLeft: "20px" }}>
                <li onClick={() => setSelectedOption("assignmentBrief")}>
                  Assignments Schedule
                </li>
                <li onClick={() => setSelectedOption("assignmentSubmission")}>
                  Assignment Submission
                </li> 

                <li onClick={() => setSelectedOption("submittedAssignment")}>
                 View Submitted Assignments
                </li> 

                <li onClick={() => setSelectedOption("assignmentPlacement")}>
                  Placement Assignment
                </li> 
                  </ul>
                )} 
           {/* <li onClick={() => setSelectedOption("submittedAssignment")}>Submitted Assignments Record</li> */}
           <li onClick={() => setSelectedOption("previousLecVideo")}>Previous Lecture Recordings</li>
           <li onClick={() => setSelectedOption("quizMaster")}>Quiz Master</li>




           {/* <li onClick={() => setSelectedOption("results")}>Results</li> */}


 <li onClick={toggleResultsDropdown} style={{ cursor: "pointer" }}>
              Results {isResultsDropdownOpen ? "▼" : "▶"}
            </li>
            {isResultsDropdownOpen && (
              <ul style={{ paddingLeft: "20px" }}>
                <li onClick={() => setSelectedOption("assignmentResults")}>
                  Assignment Results
                </li>
                <li onClick={() => setSelectedOption("continuouslyAssessmentResults")}>
                  Continuous Assessment Results
                </li>
                <li onClick={() => setSelectedOption("practicalExamResults")}>
                  Practical Exam Results
                </li> 
                <li onClick={() => setSelectedOption("finalExamResults")}>
                 Final Exam Results
                </li> 

                <li onClick={() => setSelectedOption("resultsOverview")}>
                 Results Overview
                </li> 

                  </ul>
                )} 

           <li onClick={() => setSelectedOption("notice")}>Notice Board</li>
           <li onClick={() => setSelectedOption("letter")}>Letter / Inquiry</li>
           <li className="logout-button" onClick={handleLogout}>Logout</li>
         </ul>
       </div>






      {/* Main Panel */}
      <div className="student-panel">
        {selectedOption === "home" && (
          <div className="home-section">
            <div className="home-content">
            <img
              src="/logo.jpg" 
              alt="Eye Care Institute"
              className="home-image"
            />
              <p className="home-description">
             We are a leading non-state higher education institute, approved by the Ministry of Education and accredited 
             by the Tertiary & Vocational Education Commission (TVEC). Additionally, we are members of the World Council of Optometry (WCO) 
             and the Asia Pacific Council of Optometry (APCO). Our Optician and Optometry courses are recognized by the Ceylon Council of
             Optometrists & Orthoptists (CCOO), Sri Lanka. ECI is the first Sri Lankan private institute to be recognized by the 
             Government of Sri Lanka. We are the only Optometry institute affiliated with a university.
              </p>
            </div>

            <div className="vision-mission">
              <div className="vision">
                <h2>Our Vision</h2>
                <p>
                  To be the leader in professional eye care organization by improving the quality
                  and quantity of the service providers in all eye care segments in the region.
                </p>
              </div>

              <div className="mission">
                <h2>Our Mission</h2>
                <p>
                  Improve the quality of life in the region by integrating, sharing, and enhancing
                  experience and innovation with professionals involved in eye care.
                </p>
              </div>
            </div>
          </div>
        )}







{selectedOption === "assignmentPlacement" && (
  <div className="assignment-placement-container">
    <h1 className="student-panel-title">Placement Assignments</h1>
    
    {loading ? (
      <div className="loading-message">Loading assignments...</div>
    ) : error ? (
      <div className="error-message">
        <p>{error}</p>
        <p>Please ensure your profile has correct batch and registration number.</p>
      </div>
    ) : placements.length > 0 ? (
      <div className="table-responsive">
        <table className="placements-table">
          <thead>
            <tr>
              <th>Course</th>
              <th>Batch</th>
              <th>Placement No.</th>
              <th>Upload Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {placements.map((placement) => (
              <tr key={placement.id}>
                <td>{placement.course}</td>
                <td>{placement.batch}</td>
                <td>{placement.noOfPlacement}</td>
                <td>{placement.createdAt?.toLocaleDateString()}</td>
                <td>
                  <a 
                    href={placement.fileUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="download-btn"
                  >
                    Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="no-placements">
        <p>No placement assignments found matching:</p>
        <ul>
          <li>Batch: {userData?.batch || 'Not available'}</li>
          <li>Course: {userData?.registrationNumber ? 
                (userData.registrationNumber.startsWith('DO') ? 'DO' :
                 userData.registrationNumber.startsWith('CO') ? 'CO' :
                 userData.registrationNumber.startsWith('HDO') ? 'HDO' : 'Unknown')
                : 'Not available'}
          </li>
        </ul>
      </div>
    )}
  </div>
)}








{selectedOption === "continuouslyAssessmentResults" && (
  <div className="student-profile-second">
    <h1 className="student-panel-title">Continuous Assessment Results</h1>
    <div className="results-container">
      {loading ? (
        <p>Loading results...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : continuousAssessmentResults.length > 0 ? (
        <table className="results-table">
          <thead>
            <tr>
              <th>Assessment Date</th>  
              <th>Attempt No</th>  
              <th>Module Code</th>
              <th>Module Name</th>
              <th>Semester</th>
              <th>Grade</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody>
            {continuousAssessmentResults.map((result, index) => (
              <tr key={index}>
                <td>{result.date}</td>
                <td>{result.attemptNo}</td>
                <td>{result.moduleCode}</td>
                <td>{result.moduleName}</td>
                <td>{result.semester}</td>
                <td>{result.grade}</td>
                <td>{result.remark}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No continuous assessment results found.</p>
      )}
    </div>
  </div>
)}






    {selectedOption === "practicalExamResults" && (
                    <div className="student-profile-second">
                      <h1 className="student-panel-title">Practical Exam Results</h1>
                       <div className="results-container">
      {loading ? (
        <p>Loading results...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : practicalExamResults.length > 0 ? (
        <table className="results-table">
          <thead>
            <tr>
              <th>Exam Date</th>  
              <th>Attempt No</th>
              <th>Module Code</th>
              <th>Module Name</th>
              <th>Semester</th>
              <th>Grade</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody>
            {practicalExamResults.map((result, index) => (
              <tr key={index}>
                <td>{result.date}</td>
                <td>{result.attemptNo}</td>
                <td>{result.moduleCode}</td>
                <td>{result.moduleName}</td>
                <td>{result.semester}</td>
                <td>{result.grade}</td>
                <td>{result.remark}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No Practical Exam Results found.</p>
      )}
    </div>
    </div>
  )}







                 {selectedOption === "finalExamResults" && (
         <div className="results-container">
            <h1 className="student-panel-title">Final Exam Results</h1>
  <div className="table-scroll">
    <table className="results-table">
      <thead>
        <tr>
          <th>Exam Date</th>
          <th>Attempt No</th>
          <th>Module Code</th>
          <th>Module Name</th>
          <th>Semester</th>
          <th>Grade</th>
          <th>Remark</th>
        </tr>
      </thead>
      <tbody>
        {finalExamResults.map((result, index) => (
          <tr key={index}>
            <td>{result.date}</td>
            <td>{result.attemptNo}</td>
            <td>{result.moduleCode}</td>
            <td>{result.moduleName}</td>
            <td>{result.semester}</td>
            <td>{result.grade}</td>
            <td>{result.remark}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>
              )}





            {selectedOption === "assignmentResults" && (
                    <div className="student-profile-second">
                      <h1 className="student-panel-title">Assignment Results</h1>
                       <div className="results-container">

                          {loading ? (
                            <p>Loading results...</p>
                          ) : error ? (
                            <p className="error-message">{error}</p>
                          ) : assignmentResults.length > 0 ? (
                            <table className="results-table">
                              <thead>
                                <tr>
                                  <th>Submitted Date</th> 
                                  <th>Attempt No</th> 
                                  <th>Module Code</th>
                                  <th>Module Name</th>
                                  <th>Semester</th>
                                  <th>Grade</th>
                                  <th>Remark</th>
                                </tr>
                              </thead>
                              <tbody>
                                {assignmentResults.map((result, index) => (
                                  <tr key={index}>
                                    <td>{result.date}</td>
                                    <td>{result.attemptNo}</td>
                                    <td>{result.moduleCode}</td>
                                    <td>{result.moduleName}</td>
                                    <td>{result.semester}</td>
                                    <td>{result.grade}</td>
                                    <td>{result.remark}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <p>No Assignment Results found.</p>
                          )}
                        </div>
                      </div>
                   )}




{/* {selectedOption === "resultsOverview" && (
  <div className="student-profile-second">
    <h1 className="student-panel-title">Results Overview</h1>
    <div className="results-table-container">
      {continuousAssessmentResults.length > 0 || 
       practicalExamResults.length > 0 || 
       finalExamResults.length > 0 || 
       assignmentResults.length > 0 ? (
        <table className="results-table">
          <thead>
            <tr>
              <th>Module</th>
              <th>Module Code</th>
              <th>Assignment Result</th>
              <th>Continuous Assessment</th>
              <th>Practical Exam</th>
              <th>Final Exam</th>
            </tr>
          </thead>
          <tbody>
            {getCombinedResults().map((result, index) => (
              <tr key={index}>
                <td>{result.moduleName}</td>
                <td>{result.moduleCode}</td>
                <td>{getResultForModule(assignmentResults, result.moduleCode)}</td>
                <td>{getResultForModule(continuousAssessmentResults, result.moduleCode)}</td>
                <td>{getResultForModule(practicalExamResults, result.moduleCode)}</td>
                <td>{getResultForModule(finalExamResults, result.moduleCode)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="no-results">No results found for any category.</p>
      )}
    </div>
  </div>
)} */}






          {selectedOption === "resultsOverview" && (
            <div className="student-profile-second">
              <h1 className="student-panel-title">Results Overview</h1>
              <div className="results-table-container">
                {continuousAssessmentResults.length > 0 || 
                practicalExamResults.length > 0 || 
                finalExamResults.length > 0 || 
                assignmentResults.length > 0 ? (
                  <table className="results-table">
                    <thead>
                      <tr>
                        <th>Module</th>
                        <th>Module Code</th>
                        <th>Assignment Result</th>
                        <th>Continuous Assessment</th>
                        <th>Practical Exam</th>
                        <th>Final Exam</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getCombinedResults().map((result, index) => {
                        const assignment = getResultForModule(assignmentResults, result.moduleCode);
                        const continuous = getResultForModule(continuousAssessmentResults, result.moduleCode);
                        const practical = getResultForModule(practicalExamResults, result.moduleCode);
                        const final = getResultForModule(finalExamResults, result.moduleCode);
                        
                        const status = calculateStatus(assignment, continuous, practical, final);
                        
                        return (
                          <tr key={index}>
                            <td>{result.moduleName}</td>
                            <td>{result.moduleCode}</td>
                            <td>{assignment === 'N/A' ? '-' : assignment}</td>
                            <td>{continuous === 'N/A' ? '-' : continuous}</td>
                            <td>{practical === 'N/A' ? '-' : practical}</td>
                            <td>{final === 'N/A' ? '-' : final}</td>
                            <td className={`status-${status.toLowerCase()}`}>
                              {status}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <p className="no-results">No results found for any category.</p>
                )}
              </div>
            </div>
          )}






{/*************************************************** View Submitted Assignment  **************************************************************/}


{selectedOption === "submittedAssignment" && (
  <div className="student-profile-second">
    <h1 className="student-panel-title">Submitted Assignments</h1>
    
    {loading ? (
      <div className="loading-spinner">Loading your submissions...</div>
    ) : submittedAssignments.length > 0 ? (
      <div className="submitted-assignments-container">
        <table className="submitted-assignments-table">
          <thead>
            <tr>
              <th>Module Code</th>
              <th>Module Name</th>
              <th>Assignment</th>
              <th>Submission Date</th>
              <th>Deadline</th>
              <th>Status</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {submittedAssignments.map((assignment, index) => (
              <tr key={index}>
                <td data-label="Module Code">{assignment.moduleCode}</td>
                <td data-label="Module Name">{assignment.moduleName}</td>
                <td data-label="Assignment">
                  {assignment.originalFileName || assignment.fileName}
                </td>
                <td data-label="Submission Date">
                  {new Date(assignment.submissionTime).toLocaleString()}
                </td>
                <td data-label="Deadline">
                  {assignment.submissionDeadline || "N/A"}
                </td>
                <td data-label="Status" className={`status-${assignment.status.toLowerCase()}`}>
                  {assignment.status}
                </td>
                <td data-label="Download">
                  <a
                    href={assignment.downloadURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="download-btn"
                    download
                  >
                    Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <div className="no-submissions">
     <p>The latest LMS update was released on 23 June 2026. As a result, all submitted assignments will be visible here from that date onward.</p>

      </div>
    )}
  </div>
)}






{/*************************************************** Student Profile **************************************************************/}



                  {selectedOption === "profile" && (
                    <div className="student-profile-second">
                      <h1 className="student-panel-title">Student Profile</h1>
                      {profileData ? (
                        <div className="profile-details">
                          <div className="profile-row">
                            <strong>Email :</strong> <span>{profileData.email}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Registration Number :</strong> <span>{profileData.registrationNumber}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Course :</strong> <span>{profileData.program}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Course Type :</strong> <span>{profileData.courseType}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Batch :</strong> <span>{profileData.batch}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Address :</strong> <span>{profileData.address}</span>
                          </div>
                          <div className="profile-row">
                            <strong>First Name :</strong> <span>{profileData.firstName}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Last Name :</strong> <span>{profileData.lastName}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Full Name :</strong> <span>{profileData.fullName}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Name with Initial :</strong> <span>{profileData.nameWithInitial}</span>
                          </div>
    
                          <div className="profile-row">
                            <strong>NIC/Passport :</strong> <span>{profileData.nicPassport}</span>
                          </div>
                          <div className="profile-row">
                            <strong>Contact no :</strong> <span>{profileData.contactNo}</span>
                          </div>
                          <div>
                            <strong>Name to be appeared on certificate : </strong> <span>{profileData.nameToBeAppeared}</span>
                            </div>

                                    </div>
                                  ) : (
                                    <p className="loading-text">Loading profile data...</p>
                                  )}
                                                {/* Lock Image */}
                                                <img
                                    src={`${process.env.PUBLIC_URL}/imglock.png`}
                                    alt="Profile Lock"
                                    className="profile-lock-image"
                                  />
                                </div>
                    )}


{/*************************************************** Study Materials **************************************************************/}


  {selectedOption === "studyMaterials" && (
  <div className="study-materials-container">
      <h1 className="student-panel-title">Study Materials</h1>
      <p className="quiz-master-description">
        Best practices for your academic journey.
      </p>

      {loading ? (
        <p>Loading study materials...</p>
      ) : (
        <>
          {/* Google Classroom Links Table */}
          <h2>Google Classroom Links</h2>
          {googleClassroomLinks.length > 0 ? (
            <div className="scroll-container">
              <table className="study-material-table">
                <thead>
                  <tr>
                    <th>Module Name</th>
                    <th>Link</th>
                    <th>Uploaded At</th>
                  </tr>
                </thead>
                <tbody>
                  {googleClassroomLinks.map((link) => (
                    <tr key={link.id}>
                      <td>{link.moduleName}</td>
                      <td>
                        <a href={link.googleclassroomLink} target="_blank" rel="noopener noreferrer">
                          Open Link
                        </a>
                      </td>
                      <td>{link.createdAt?.toDate().toLocaleString() || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>No Google Classroom links available.</p>
          )}

          {/* Uploaded Files Table */}
          <h2 style={{ marginTop: "20px" }}>Uploaded Files</h2>
          {studyMaterialFiles.length > 0 ? (
            <div className="scroll-container">
              <table className="study-material-table">
                <thead>
                  <tr>
                    <th>Module Name</th>
                    <th>File</th>
                    <th>Uploaded At</th>
                  </tr>
                </thead>
                <tbody>
                  {studyMaterialFiles.map((file) => (
                    <tr key={file.id}>
                      <td>{file.moduleName}</td>
                      {/* <td>
                        <a href={file.fileUrl} target="_blank" rel="noopener noreferrer">
                          {file.fileUrl.split("_").pop()}
                        </a>
                      </td> */}


<td>
  <button
    onClick={() => window.open(file.fileUrl, "_blank")}
    className="open-file-button"
  >
    Open File
  </button>
</td>


                      <td>{file.createdAt?.toDate().toLocaleString() || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p>No files uploaded.</p>
          )}
        </>
      )}
    </div>
)}


{/*************************************************** Learning Resources **************************************************************/}



                 {selectedOption === "learningResources" && (
                    <div className="quiz-master-container">
                      <h1 className="student-panel-title">Learning Resources</h1>
                      <p className="quiz-master-description">
                        Best practices for your academic journey.
                      </p>
                      <div className="quiz-master-link">
                        
                      <table>
                        <thead>
                          <tr>
                            <th>Learning Resources</th>
                          </tr>
                        </thead>
                        <tbody>
                          
                        <tr>
                            <td>
                              <a
                                href="https://www.aao.org/ophthalmologists"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                 American Academy of Ophthalmology 
                              </a>
                            </td>
                            </tr>

                           <tr>
                            <td>
                              <a
                                href="https://www.reviewofoptometry.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Contact Lens Spectrum
                              </a>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <a
                                href="https://optometry-today.com/contact-lenses/"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Optometry Today
                              </a>
                            </td>
                            </tr>



                            <tr>
                            <td>
                              <a
                                href="https://www.healio.com/ophthalmology"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                 Ophthalmic Hyperguide 
                              </a>
                            </td>
                            </tr>

                            <tr>
                            <td>
                              <a
                                href="https://www.reviewofoptometry.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Review of Optometry
                              </a>
                            </td>
                           </tr>

                        </tbody>
                      </table>
                    </div>

                    </div>
                  )}



{/*************************************************** Quiz Master **************************************************************/}



                {/* {selectedOption === "previousLecVideo" && (
                    <div className="quiz-master-container">
                      <h1 className="student-panel-title">Previous Lecture Recordings</h1>
                      <p className="quiz-master-description">
                        Best practices for your academic journey.
                      </p>
                      <div className="quiz-master-link">
                      {lectureRecordingLink.length > 0 ? (
                      <table>
                        <thead>
                          <tr>
                          <th>Module</th>
                          <th>Session No.</th>
                          <th>Lecture Video Link</th>
                          </tr>
                        </thead>
                        <tbody>
                            {lectureRecordingLink.map((link) => (
                              <tr key={link.id}>
                                <td>{link.moduleName}</td>
                                <td>{link.session}</td>
                                <td>
                                  <a href={link.lectureRecordingLink} target="_blank" rel="noopener noreferrer">
                                    Open Lecture Recording
                                  </a>
                                </td>
                              </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            <p>No previous Lecture Video available at the moment.</p>
                          )}
                              </div>
                            </div>
            )} */}


            {/* {selectedOption === "previousLecVideo" && (
  <div className="previous-lecture-container">
    <h1 className="student-panel-title">Previous Lecture Recordings</h1>
    <p className="previous-lecture--description">
      Best practices for your academic journey.
    </p>
    <div className="previous-lecture-link">
      {lectureRecordingLink.length > 0 ? (
        lectureRecordingLink.map((module) => (
          <div key={module.moduleName} className="module-section">
            <h3>{module.moduleName}</h3>
            <table>
              <thead>
                <tr>
                  <th>Session No.</th>
                  <th>Lecture Video Link</th>
                </tr>
              </thead>
              <tbody>
                {module.sessions.map((session) => (
                  <tr key={session.id}>
                    <td>{session.session}</td>
                    <td>
                      <a href={session.lectureRecordingLink} target="_blank" rel="noopener noreferrer">
                        Open Lecture Recording
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      ) : (
        <p>No previous Lecture Video available at the moment.</p>
      )}
    </div>
  </div>
)} */}








{/*************************************************** Previous Lecture Recordings **************************************************************/}

          {/* {selectedOption === "previousLecVideo" && (
        <div className="previous-lecture-container">
          <h1 className="student-panel-title">Previous Lecture Recordings</h1>
          <p className="previous-lecture--description">
            Best practices for your academic journey.
          </p>


          <div className="lecture-controls">
            <div className="search-filter-container">
              <input
                type="text"
                placeholder="Search recordings..."
                className="materials-search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              <div className="filter-dropdowns">
                <select
                  className="filter-dropdown"
                  value={moduleFilter}
                  onChange={(e) => setModuleFilter(e.target.value)}
                >
                  <option value="">All Modules</option>
                  {Array.isArray(lectureRecordingLink) &&
                    [...new Set(lectureRecordingLink.map((m) => m.moduleName))].map(
                      (module) => (
                        <option key={module} value={module}>
                          {module}
                        </option>
                      )
                    )}
                </select>
              </div>
            </div>
          </div>

          <div className="previous-lecture-link">
            {Array.isArray(filteredRecordings) && filteredRecordings.length > 0 ? (
              filteredRecordings.map((module) => (
                <div key={module.moduleName} className="module-section">
                  <h3>{module.moduleName}</h3>
                  <table>
                    <thead>
                      <tr>
                        <th>Session No.</th>
                        <th>Lecture Video Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      {module.sessions.map((session) => (
                        <tr key={session.id}>
                          <td>{session.session}</td>
                          <td>
                            <a
                              href={session.lectureRecordingLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open Lecture Recording
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ))
            ) : (
              <p>No matching lecture recordings found.</p>
            )}
          </div>
        </div>
      )} */}

{selectedOption === "previousLecVideo" && (
          <div className="previous-lecture-container">
      <h1 className="student-panel-title">Previous Lecture Recordings</h1>

      <div className="lecture-controls">
        <input
          type="text"
          placeholder="Search recordings..."
          className="materials-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <select
          className="filter-dropdown"
          value={moduleFilter}
          onChange={(e) => setModuleFilter(e.target.value)}
        >
          <option value="">All Modules</option>
          {Array.isArray(lectureRecordingLink) &&
            [...new Set(lectureRecordingLink.map((m) => m.moduleName))].map(
              (module) => (
                <option key={module} value={module}>
                  {module}
                </option>
              )
            )}
        </select>
      </div>

      <div className="previous-lecture-link">
        {filteredRecordings.length > 0 ? (
          filteredRecordings.map((module) => (
            <div key={module.moduleName} className="module-section">
              <h3>{module.moduleName}</h3>
              <table>
                <thead>
                  <tr>
                    <th>Session / Part</th>
                    <th>Lecture Video</th>
                  </tr>
                </thead>
                <tbody>
                  {module.sessions.map((session) => {
                    const key = `${module.moduleName}-${session.sessionName}`;
                    const expanded = expandedSessions[key];

                    return (
                      <React.Fragment key={key}>
                        {/* SESSION ROW */}
                        <tr className="session-row">
                          <td colSpan="2">
                            {session.parts.length > 1 && (
                              <button
                                className="expand-btn"
                                onClick={() =>
                                  toggleSession(module.moduleName, session.sessionName)
                                }
                              >
                                {expanded ? "➖" : "➕"}
                              </button>
                            )}{" "}
                            <strong>{session.sessionName}</strong>
                          </td>
                        </tr>

                        {/* PART ROWS */}
                        {(expanded || session.parts.length === 1) &&
                          session.parts.map((part) =>
                            part.lectureRecordingLink.map((link, idx) => (
                              <tr key={`${part.id}-${idx}`} className="part-row">
                                <td style={{ paddingLeft: "40px" }}>{part.part}</td>
                                <td>
                                  <a
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Open Lecture Recording
                                  </a>
                                </td>
                              </tr>
                            ))
                          )}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ))
        ) : (
          <p>No lecture recordings found.</p>
        )}
      </div>
    </div>
      )}


{/*************************************************** Payments **************************************************************/}




        {selectedOption === "payment" && (
                <div className="payment-container">
                  <h1 className="student-panel-title">Payments</h1>
                  <div className="payment-summary">
                    <p>
                      <span>Course Fee:</span>
                      <span className="value">Rs. {courseFee}</span>
                    </p>


                    <p>
                      <span>Amount Paid:</span>
                      <span className="value">Rs. {totalAmountPaid}</span>
                    </p>
                    <p>
                      <span>Outstanding Amount:</span>
                      <span className="value">Rs. {outstandingAmount}</span>
                    </p>
                  </div>

                  {payments.length > 0 ? (
                    <table className="payment-table">
                      <thead>
                        <tr>
                          <th>Receipt No</th>
                          <th>Payment Type</th>
                          <th>Amount</th>
                          <th>Payment Date</th>
                          <th>Payment For Month</th>
                          <th>Remark</th>
                        </tr>
                      </thead>
                      <tbody>
                        {payments.map((payment) => (
                          <tr key={payment.id}>
                            <td>{payment.receiptNo}</td>
                            <td>{payment.paymentType}</td>
                            <td>{payment.amount}</td>
                            <td>{new Date(payment.paymentDate.seconds * 1000).toLocaleDateString()}</td>
                            <td>{payment.paymentForMonth || "-"}</td>
                            <td>{payment.remark}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p>No payments found.</p>
                  )}
                </div>
              )}


{/*************************************************** module **************************************************************/}


          {selectedOption === "module" && (
            <div className="modules-container">
              <h1 className="student-panel-title">Course Modules</h1>
              {loading && <p className="loading-message">Loading...</p>}

              {error && <p className="error-message">{error}</p>}

              {!loading && !error && modules.length > 0 ? (
                <table className="modules-table">
                  <thead>
                    <tr>
                      <th>Semester</th>
                      <th>Module Code</th>
                      <th>Module Name</th>
                     

                    </tr>
                  </thead>
                  <tbody>
                      {modules
                        .slice() // Create a shallow copy of the array to avoid mutating the original
                        .sort((a, b) => a.moduleCode.localeCompare(b.moduleCode)) // Sort by moduleCode
                        .map((module, index) => (
                          <tr key={index}>
                            <td>{module.semester}</td>
                            <td>{module.moduleCode}</td>
                            <td>{module.moduleName}</td>
                          
                          </tr>
                        ))}
                    </tbody>
                </table>
              ) : (
                <p className="no-modules-message">No modules found</p>
              )}
            </div>
          )}



{/******************************************************** materials ********************************************************************/}



          {selectedOption === "materials" && (
            <>
              <h1 className="student-panel-title">Lecture Materials</h1>
              <p className="student-panel-description">
                Access lecture slides, reading materials, and additional resources for your courses.
              </p>

              {/* Search and Filter Controls */}
              <div className="materials-controls">
                <div className="search-filter-container">
                  <input
                    type="text"
                    placeholder="Search materials..."
                    className="materials-search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  
                  <div className="filter-dropdowns">
                    <select 
                      className="filter-dropdown"
                      value={moduleFilter}
                      onChange={(e) => setModuleFilter(e.target.value)}
                    >
                      <option value="">All Modules</option>
                      {[...new Set(materials.map(m => m.moduleName))].map(module => (
                        <option key={module} value={module}>{module}</option>
                      ))}
                    </select>
                    
                    <select 
                      className="filter-dropdown"
                      value={codeFilter}
                      onChange={(e) => setCodeFilter(e.target.value)}
                    >
                      <option value="">All Codes</option>
                      {[...new Set(materials.map(m => m.moduleCode))].map(code => (
                        <option key={code} value={code}>{code}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {loading ? (
                <p className="loading-message">Loading materials...</p>
              ) : error ? (
                <p className="error-message">{error}</p>
              ) : materials.length > 0 ? (
                <div className="materials-table-container">
                  <table className="materials-table">
                    <thead>
                      <tr>
                        <th>Module Name</th>
                        <th>Module Code</th>
                        <th>Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {materials
                        .filter(material => {
                          // Apply search term filter
                          const matchesSearch = 
                            material.moduleName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                            material.moduleCode.toLowerCase().includes(searchTerm.toLowerCase());
                          
                          // Apply module filter
                          const matchesModule = 
                            !moduleFilter || material.moduleName === moduleFilter;
                          
                          // Apply code filter
                          const matchesCode = 
                            !codeFilter || material.moduleCode === codeFilter;
                          
                          return matchesSearch && matchesModule && matchesCode;
                        })
                        .sort((a, b) => {
                          const moduleCodeComparison = a.moduleCode.localeCompare(b.moduleCode);
                          if (moduleCodeComparison !== 0) return moduleCodeComparison;
                          
                          const sessionA = a.moduleName.match(/\d+/);
                          const sessionB = b.moduleName.match(/\d+/);
                          
                          if (sessionA && sessionB) {
                            return parseInt(sessionA[0], 10) - parseInt(sessionB[0], 10);
                          }
                          return 0;
                        })
                        .map((material) => (
                          <tr key={`${material.id}-${material.documentId}`}>
                            <td>{material.moduleName}</td>
                            <td>{material.moduleCode}</td>
                            <td>
                              <a href={material.fileUrl} target="_blank" rel="noopener noreferrer">
                                Download PDF <span className="download-icon">⬇️</span>
                              </a>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="no-materials-message">
                  No materials available for your batch and program.
                </p>
              )}
            </>
          )}




        
{/* {selectedOption === "materials" && (
  <>
    <h1 className="student-panel-title">Lecture Materials</h1>
    <p className="student-panel-description">
      Access lecture slides, reading materials, and additional resources for your courses.
    </p>

    {loading ? (
      <p className="loading-message">Loading materials...</p>
    ) : error ? (
      <p className="error-message">{error}</p>
    ) : materials.length > 0 ? (
      <div className="materials-table-container">
        <table className="materials-table">
          <thead>
            <tr>
              <th>Module Name</th>
              <th>Module Code</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {materials
              .slice() // Create a shallow copy of the array to avoid mutating the original
              .sort((a, b) => {
                // First, sort by moduleCode in ascending order
                const moduleCodeComparison = a.moduleCode.localeCompare(b.moduleCode);
                if (moduleCodeComparison !== 0) return moduleCodeComparison;
                
                // Extract session number if available
                const sessionA = a.moduleName.match(/\d+/);
                const sessionB = b.moduleName.match(/\d+/);
                
                if (sessionA && sessionB) {
                  return parseInt(sessionA[0], 10) - parseInt(sessionB[0], 10);
                }
                return 0;
              })
              .map((material) => (
                <tr key={`${material.id}-${material.documentId}`}>
                  <td>{material.moduleName}</td>
                  <td>{material.moduleCode}</td>
                  <td>
                    <a href={material.fileUrl} target="_blank" rel="noopener noreferrer">
                      Download PDF <span className="download-icon">⬇️</span>
                    </a>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    ) : (
      <p className="no-materials-message">
        No materials available for your batch and program.
      </p>
    )}
  </>
)} */}



{/*************************************************** Guidelines **************************************************************/}

        {selectedOption === "guidelines" && (
          <>
            <h1 className="student-panel-title">Course Guidelines</h1>
            <p className="student-guidlines-description">
              Review guidelines, policies, and best practices for your academic journey.
            </p><br />


            <div className="guidelines-downloads">
              <ul>

                <li>
                  <a href="/placementreport.doc" download>
                    Download Student Placement Report
                    <span className="download-icon">⬇️</span> {/* Add the download icon */}
                  </a>
                </li>
                
                {/* <li>
                  <a href="/examapplication.pdf" download>
                    Download Exam Application 
                    <span className="download-icon">⬇️</span> 
                  </a>
                </li> */}

                <li>
                  <a href="/Eye Care Institute Course Detail.pdf" download>
                    Download Eye Care Institute Course Details 
                    <span className="download-icon">⬇️</span> {/* Add the download icon */}
                  </a>
                </li>
                <li>
                  <a href="/Guidelines.pdf" download>
                    Download Course Guidelines 
                    <span className="download-icon">⬇️</span> {/* Add the download icon */}
                  </a>
                </li>
                <li>
                  <a href="/studentfeedback.pdf" download>
                    Download Lecturer Evaluation 
                    <span className="download-icon">⬇️</span> {/* Add the download icon */}
                  </a>
                </li>
              </ul>
            </div>

            <br />
            <p className="student-guidlines-description">Your Lecturer Evaluation Report is available for download. Please review it to provide feedback on your learning experience. Send your evaluation via <b>instituteyecare@gmail.com</b></p>
            <p className="student-guidlines-description">Download the Student Placement Report to view your placement details and opportunities.</p>

          </>
        )}


         
{/*************************************************** Assignment Brief **************************************************************/}


                    
            {selectedOption === "assignmentBrief" && (
              <div className="assignments-container">
                <h1 className="student-panel-title">Assignments Schedule</h1>
                {assignments.length > 0 ? (
                  <table className="assignments-table">
                    <thead>
                      <tr>
                        <th>Module Code</th>
                        <th>Module Name</th>
                        <th>Issue Date</th>
                        <th>Submission Date</th>
                        <th>Assignment Brief</th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignments.map((assignment, index) => (
                        <tr key={index}>
                          <td>{assignment.moduleCode}</td>
                          <td>{assignment.moduleName}</td>
                          <td>{assignment.issueDate}</td>
                          <td>{assignment.submissionDate}</td>
                          <td>
                          <a
                            href={assignment.fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="download-link"
                          >
                           
                            Download Assignment Brief <span className="download-icon">⬇️</span> {/* Add the download icon */}
                          </a>

                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p>No assignments available.</p>
                )}
              </div>
            )}




{/*******************************************************   Assignment Submission **************************************************************/}





                {selectedOption === "assignmentSubmission" && (
                  <div className="assignment-submission-container">
                    <h1 className="student-panel-title">Assignment Submission</h1>

                    <div className="file-rename-format">
                      <h2>Rename your assignment according to the below format</h2>
                      <p>Batch_ModuleCode_Name_RegistrationNumber</p>
                      <p><strong>Example:</strong> 2025-01_CO101_Kamal_CO-9657890975</p>
                    </div>

                    {loading ? (
                      <p>Loading assignments...</p>
                    ) : assignmentDeadlines.length > 0 ? (
                      <table className="assignment-table">
                        <thead>
                          <tr>
                            <th>Module Code</th>
                            <th>Module Name</th>
                            <th>Submission Deadline</th>
                            <th>Upload</th>
                          </tr>
                        </thead>
                        <tbody>
                          {assignmentDeadlines.map((assignment, index) => {
                            const firestoreTimestamp = assignment.submissionDeadline;
                            let deadline;

                            try {
                              if (firestoreTimestamp instanceof Date) {
                                deadline = firestoreTimestamp;
                              } else if (firestoreTimestamp?.seconds) {
                                deadline = new Date(firestoreTimestamp.seconds * 1000);
                              } else {
                                deadline = new Date(firestoreTimestamp);
                              }
                            } catch (error) {
                              console.error("Timestamp conversion error:", error);
                              return (
                                <tr key={index}>
                                  <td>{assignment.moduleCode}</td>
                                  <td>{assignment.moduleName}</td>
                                  <td className="error-text">Invalid timestamp format</td>
                                  <td>-</td>
                                </tr>
                              );
                            }

                            if (!deadline || isNaN(deadline.getTime())) {
                              return (
                                <tr key={index}>
                                  <td>{assignment.moduleCode}</td>
                                  <td>{assignment.moduleName}</td>
                                  <td className="error-text">Invalid date value</td>
                                  <td>-</td>
                                </tr>
                              );
                            }

                            const options = {
                              timeZone: 'Asia/Kolkata',
                              month: 'long',
                              day: 'numeric',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: true
                            };

                            const formattedDeadline = deadline.toLocaleString('en-US', options);
                            const currentTime = new Date();
                            const isDeadlinePassed = currentTime > deadline;
                            const hoursRemaining = Math.max(
                              0,
                              Math.round((deadline - currentTime) / (1000 * 60 * 60))
                            );

                            return (
                              <tr key={index}>
                                <td>{assignment.moduleCode}</td>
                                <td>{assignment.moduleName}</td>
                                <td>
                                  {formattedDeadline}
                                  {!isDeadlinePassed && (
                                    <div className="deadline-warning">
                                      {hoursRemaining > 24
                                        ? `${Math.floor(hoursRemaining / 24)} days remaining`
                                        : `${hoursRemaining} hours remaining`}
                                    </div>
                                  )}
                                </td>
                                <td data-label="Upload">
                                  {isDeadlinePassed ? (
                                    <button disabled className="disabled-upload-button">
                                      Deadline Passed
                                    </button>
                                  ) : (
                                    <form
                                      onSubmit={(e) => handleFileUpload(e, assignment.moduleCode)}
                                      className="upload-form"
                                    >
                                      <input type="file" name="file" required />
                                      <button type="submit" className="assignment-button">
                                        Upload
                                      </button>
                                      <div className="upload-warning">
                                        {hoursRemaining < 24 && "Submit soon! Deadline approaching"}
                                      </div>
                                    </form>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    ) : (
                      <p>No assignments available.</p>
                    )}
                            
                    {isUploading && (
                      <div className="progress-container">
                        <div className="progress-bar" style={{ width: `${uploadProgress}%` }}>
                          {Math.round(uploadProgress)}%
                        </div>
                      </div>
                    )}
                  </div>
                )}









        

          {/* {selectedOption === "results" && (
            <div className="results-container">
              <h1 className="student-panel-title">Results</h1>

              {loading && <p className="loading-message">Loading results...</p>}

              {error && <p className="error-message">{error}</p>}

              {!loading && !error && results.length > 0 ? (
                <table className="results-table">
                  <thead>
                    <tr>
                      <th>Semester</th>
                      <th>Type Of Assessment</th>
                      <th>Module Code</th>
                      <th>Module</th>
                      <th>Grade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {results.map((result, index) => (
                      <tr key={index}>
                        <td>{result.semester}</td>
                        <td>{result.typeOfAssesment}</td>
                        <td>{result.moduleCode}</td>
                        <td>{result.moduleName}</td>
                        <td>{result.grade}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="no-results-message">No results found.</p>
              )}
            </div>
          )} */}




{/************************************ notice board  ******************************************************************/}



            {selectedOption === "notice" && (
              <div>
                <h1 className="student-panel-title">Notice Board</h1>
                <div className="notice-container">
                  {notices.length > 0 ? (
                    notices.map(notice => (
                      <div key={notice.id} className="notice-item">
                        <h3>{notice.subject}</h3>            <h3 className="notice-date">
                          {new Date(notice.addedDate.seconds * 1000).toLocaleString()}
                        </h3>
                        <p className="notice-content">{notice.notice}</p>
                        {notice.hasImage && notice.imageUrl && (
                          <div className="notice-image-container">
                            <img 
                              src={notice.imageUrl} 
                              alt="Notice attachment" 
                              className="notice-image"
                              onClick={() => setSelectedImage(notice.imageUrl)}
                            />
                          </div>
                        )}

                      </div>
                    ))
                  ) : (
                    <p>No notices available.</p>
                  )}
                </div>

                {/* Image modal */}
                {selectedImage && (
                  <div className="image-modal" onClick={() => setSelectedImage(null)}>
                    <div className="image-modal-content">
                      <img src={selectedImage} alt="Full size notice" />
                      <button 
                        className="close-modal"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedImage(null);
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}



{/*************************************************** Inquiry / Feedback **************************************************************/}

              {selectedOption === "letter" && (
                <>
                  <h1 className="student-panel-title">Letter / Inquiry</h1>
                  <form className="contact-form" onSubmit={handleSend}>
                    <label className="form-label">Your Email</label>
                    <input
                      type="email"
                      value={studentEmail}
                      readOnly
                      className="form-input read-only"
                    />

                    <label className="form-label">Message Type</label>
                    <select
                      value={messageType}
                      onChange={(e) => setMessageType(e.target.value)}
                      className="form-input"
                    >
                      <option value="inquiry">Inquiry</option>
                      <option value="request">Request</option>
                      <option value="complaint">Complaint</option>
                      <option value="feedback">Feedback</option>
                    </select>

                    <label className="form-label">Subject</label>
                    <input
                      type="text"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                      placeholder="Enter subject"
                      className="form-input"
                      required
                    />

                    <label className="form-label">Message</label>
                    <textarea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="Write your message here"
                      className="form-textarea"
                      required
                    ></textarea>

                    <div className="form-buttons">
                      <button type="button" className="clear-button" onClick={handleClear}>
                        Clear
                      </button>
                      <button type="submit" className="send-button">
                        Send
                      </button>
                    </div>
                  </form>
                </>
              )}



      </div>
    </div>

  );
};

export default StudentDashboard;
